import React from 'react';
import { string } from 'prop-types';
import { Col } from '@thd-olt-component-react/grid';

const CarouselHeader = ({ title }) => (
  <Col>
    <div className="row-header">
      <div className="row-header__title">
        <h2 className="row-header__text">{title}</h2>
      </div>
    </div>
  </Col>
);

CarouselHeader.propTypes = {
  title: string
};

CarouselHeader.defaultProps = {
  title: ''
};

export { CarouselHeader };